import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core'
import { DatetimePickerComponent } from '../../common/datetime-picker/datetime-picker.component'
import { resolveLocalTimeZone } from '../../utils'

export type UndoSoftDeletionDialogData = {
  callId: number
  currentRetentionPeriodStartDate: Date | null
}

export type UndoSoftDeletionDialogResult = {
  retentionPeriodStartDate: Date | null
}

@Component({
  selector: 'app-undo-soft-deletion-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButton,
    MatCheckboxModule,
    TranslatePipe,
    TranslateDirective,
    MatDialogTitle,
    DatetimePickerComponent,
  ],
  templateUrl: './undo-soft-deletion-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './undo-soft-deletion-dialog.component.scss',
})
export class UndoSoftDeletionDialogComponent {
  data: UndoSoftDeletionDialogData = inject(MAT_DIALOG_DATA)

  // The picker reads and writes a plain Date, so the date is in the user's own time zone. Naming it
  // keeps it from being read as the British time the meeting screens show elsewhere.
  localTimeZone = resolveLocalTimeZone()

  setRetentionPeriodStartDate = false

  retentionPeriodStartDate: Date = this.data.currentRetentionPeriodStartDate !== null ? new Date(this.data.currentRetentionPeriodStartDate) : new Date()

  get dialogResult(): UndoSoftDeletionDialogResult {
    return {
      retentionPeriodStartDate: this.setRetentionPeriodStartDate ? this.retentionPeriodStartDate : null,
    }
  }
}
